import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { INTEGRATION_ENABLED, INTEGRATION_STATUS, IntegrationPlatform, IntegrationsFilters } from 'voxloud-types/dist/models/integrations';

@Component({
  selector: 'gdp-integrations-filters',
  templateUrl: './integrations-filters.component.html',
  styleUrls: ['./integrations-filters.component.scss']
})
export class IntegrationsFiltersComponent implements OnInit {
  @Output() filtersChanged = new EventEmitter();
  @Input() platforms: IntegrationPlatform[];
  public form: FormGroup;
  public availableFilters = ['enabled', 'platform_id', 'status'];
  public usedFilters = ['company_id'];
  public STATUSES: string[] = Object.values(INTEGRATION_STATUS);


  constructor(
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.form = this.formBuilder.group({
      company_id: new FormControl('')
    });
  }

  public addFilter(index: number) {
    let filter: string = this.availableFilters[index];
    this.usedFilters.push(this.availableFilters[index]);
    this.availableFilters.splice(index, 1);

    switch (filter) {
      case 'platform_id':
        this.form.addControl(filter, new FormControl(this.platforms[0]));
      case 'enabled':
        this.form.addControl(filter, new FormControl(INTEGRATION_ENABLED[0]));
      case 'status':
        this.form.addControl(filter, new FormControl(this.STATUSES[0]));
      default:
        this.form.addControl(filter, new FormControl(''));
        break;
    }
  }

  public updateFilters(index: number, oldIndex: number) {
    let toRemove: string = this.usedFilters[oldIndex];
    let toAdd: string = this.availableFilters[index];
    this.usedFilters[oldIndex] = this.availableFilters[index];
    this.availableFilters.splice(index, 1);

    this.availableFilters.push(toRemove);
    this.availableFilters.sort();
    this.form.removeControl(toRemove);
    switch (toAdd) {
      case 'platform_id':
        this.form.addControl(toAdd, new FormControl(this.platforms[0]));
      case 'enabled':
        this.form.addControl(toAdd, new FormControl(INTEGRATION_ENABLED[0]));
      case 'status':
        this.form.addControl(toAdd, new FormControl(this.STATUSES[0]));
      default:
        this.form.addControl(toAdd, new FormControl(''));
        break;
    }
  }

  public emitFilters(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.form.valid) {
      let platform = this.form.value.platform_id;
      
      if(platform) {
        this.form.value.platform_id = platform.id;
      }

      let values = this.form.value;
      let filters: IntegrationsFilters = {
        ...values
      };
      this.filtersChanged.emit(filters);
    }
    else this.filtersChanged.emit({});
  }

  public resetFilters() {
    this.form = this.formBuilder.group({
      company_id: new FormControl('')
    });
    this.availableFilters = ['enabled', 'platform_id', 'status'];
    this.usedFilters = ['company_id'];
  }

  public removeFilter(index: number) {
    let filter = this.usedFilters[index];
    this.availableFilters.push(this.usedFilters[index]);
    this.usedFilters.splice(index, 1);
    this.availableFilters.sort();

    this.form.removeControl(filter);
  }
}
